import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-text",
  template: `
    <ng-container *ngIf="!!editor; else other">
      <ion-input
        [maxlength]="to.maxLength || 200"
        [minlength]="to.minLength || 0"
        [formControl]="formControl"
        [ionKreFormAttributes]="field"
      ></ion-input>
    </ng-container>
    <ng-template #other>
      <div class="fieldtext">{{ text }}</div>
    </ng-template>
  `,
})
export class KreFormFieldIonText extends FieldType {
  constructor() {
    super();
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // console.log('this.text:', this.text);
  }
}
